/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* FILTER ICON — THE PERIOD, THE OPERATORS AND THE GAMES OF THE LIST */
export const FilterIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 6h18M6.5 12h11M10 18h4" />
    </Icon>
)

/* PLAYER ICON — THE SECTION ITSELF */
export const PlayerIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <circle cx="12" cy="8" r="4" />
        <path d="M4.5 20c0-3.6 3.4-6 7.5-6s7.5 2.4 7.5 6" />
    </Icon>
)

/* PLAYERS ICON — HOW MANY PEOPLE THE FILTER HOLDS */
export const PlayersIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <circle cx="9" cy="8" r="3.6" />
        <path d="M2.8 19.5c0-3.2 2.8-5.2 6.2-5.2s6.2 2 6.2 5.2" />
        <path d="M16.5 5.2a3.4 3.4 0 0 1 0 6.6M18 14.7c2.1.6 3.4 2.2 3.4 4.3" />
    </Icon>
)

/* VIP ICON — A CROWN */
export const BellIcon = ({ size = 13 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
)

export const VipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3 7.5 6.5 11 12 4.5 17.5 11 21 7.5v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </Icon>
)

/* TESTER ICON — A TEST ACCOUNT */
export const TesterIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M9.5 3v6.2L4.8 17a2.4 2.4 0 0 0 2 3.5h10.4a2.4 2.4 0 0 0 2-3.5L14.5 9.2V3" />
        <path d="M8 3h8M7.6 14h8.8" />
    </Icon>
)

/* BLOCK ICON — THE PLAYER IS NOT LET INTO THE GAMES */
export const BlockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M5.6 5.6 18.4 18.4" />
    </Icon>
)

/* EYE ICON — THE CARD OF THE PLAYER OPENS IN A MODAL */
export const EyeIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
        <circle cx="12" cy="12" r="3" />
    </Icon>
)

/* COPY ICON — THE CODE OF THE PLAYER GOES TO THE CLIPBOARD */
export const CopyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="11" height="11" rx="2.5" />
        <path d="M15 5.5A2.5 2.5 0 0 0 12.5 3H6.5A2.5 2.5 0 0 0 4 5.5v6A2.5 2.5 0 0 0 6.5 14" />
    </Icon>
)

/* DOTS ICON — THE MENU OF A ROW */
export const DotsIcon = ({ size = 16 }) => (
    <Icon size={size} width={2.6}>
        <path d="M12 5.6v.1M12 12v.1M12 18.4v.1" />
    </Icon>
)

/* TABLE ICON — THE GAME BEHIND A ROUND */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* STUDIO ICON — THE GROUP OF A TABLE */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="12.5" rx="2.5" />
        <path d="M7 21h10M12 17v4" />
    </Icon>
)

/* OPERATOR ICON — THE CASINO OF THE ACCOUNT */
export const OperatorIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20.5V6.5A2 2 0 0 1 6 4.5h6a2 2 0 0 1 2 2v14" />
        <path d="M14 10.5h4a2 2 0 0 1 2 2v8" />
        <path d="M2.5 20.5h19M7.5 8.5h3M7.5 12.5h3M7.5 16.5h3" />
    </Icon>
)

/* CALENDAR ICON — THE PERIOD OF THE LIST */
export const CalendarIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
        <path d="M3.5 10h17M8.5 3v4M15.5 3v4" />
    </Icon>
)

/* CLOCK ICON — THE TIME SPENT AT THE TABLE */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3.5 2" />
    </Icon>
)

/* SESSION ICON — ONE ENTRANCE OF THE PLAYER */
export const SessionIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M14.5 3.5H18a2.5 2.5 0 0 1 2.5 2.5v12a2.5 2.5 0 0 1-2.5 2.5h-3.5" />
        <path d="M10 16.5 14.5 12 10 7.5M14 12H3.5" />
    </Icon>
)

/* ROUND ICON — ONE HAND OF THE GAME */
export const RoundIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3.5c3 3.6 5.5 6.2 5.5 9a5.5 5.5 0 0 1-11 0c0-2.8 2.5-5.4 5.5-9Z" />
    </Icon>
)

/* LAYERS ICON — HOW MANY TRANSACTIONS THE FILTER HOLDS */
export const LayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3 21 8l-9 5-9-5Z" />
        <path d="M3 13.5l9 5 9-5" />
    </Icon>
)

/* CHIP ICON — THE AVERAGE BET */
export const ChipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="3.5" />
        <path d="M12 3.5v3M12 17.5v3M3.5 12h3M17.5 12h3" />
    </Icon>
)

/* DEBIT ICON — THE MONEY LEFT THE PLAYER */
export const DebitIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 4.5v13" />
        <path d="M7 12.5 12 17.5 17 12.5" />
    </Icon>
)

/* CREDIT ICON — THE MONEY CAME BACK TO THE PLAYER */
export const CreditIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 19.5v-13" />
        <path d="M7 11.5 12 6.5 17 11.5" />
    </Icon>
)

/* NET ICON — THE DIFFERENCE BETWEEN THE TWO */
export const NetIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3.5 17.5 9 11l4 4 7.5-8.5" />
        <path d="M15.5 6.5h5v5" />
    </Icon>
)

/* WALLET ICON — THE BALANCE OF THE ACCOUNT */
export const WalletIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3.5 7.5A2.5 2.5 0 0 1 6 5h11.5A2.5 2.5 0 0 1 20 7.5v9a2.5 2.5 0 0 1-2.5 2.5H6a2.5 2.5 0 0 1-2.5-2.5Z" />
        <path d="M3.5 9.5h13a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-13" />
        <path d="M15.4 12h.2" />
    </Icon>
)

/* CURRENCY ICON — THE MONEY OF THE ACCOUNT */
export const CurrencyIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 4.5v15" />
        <path d="M6.5 8.5h8a2.5 2.5 0 0 1 0 5h-5a2.5 2.5 0 0 0 0 5h8" />
    </Icon>
)

/* CHART ICON — THE STATISTICS OF A GAME */
export const ChartIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3.5 20.5h17" />
        <path d="M7 20.5v-6M12 20.5V6.5M17 20.5v-9" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* ALERT ICON — A TRANSACTION THE OPERATOR REFUSED */
export const AlertIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3.5 21.5 20H2.5Z" />
        <path d="M12 10v4.5M12 17.4v.6" />
    </Icon>
)

/* REFUND ICON — THE MONEY WENT BACK */
export const RefundIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 9.5h10.5a4.5 4.5 0 0 1 0 9H9" />
        <path d="M7.5 6 4 9.5 7.5 13" />
    </Icon>
)

/* ARROW ICON — THE ACCORDION OF A ROUND */
export const ArrowIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M8.5 5 15.5 12l-7 7" />
    </Icon>
)

/* BACK ICON — THE WAY BACK FROM THE ROUNDS OF A SESSION */
export const BackIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M15.5 5 8.5 12l7 7" />
    </Icon>
)

/* SORT ICON — THE ORDER OF THE LIST */
export const SortIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M7 4.5v15M7 19.5 4 16.5M7 19.5l3-3" />
        <path d="M17 19.5v-15M17 4.5 14 7.5M17 4.5l3 3" />
    </Icon>
)

/* DOWNLOAD ICON — THE REPORT OF THE SECTION */
export const DownloadIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M12 3.5v11" />
        <path d="M7.5 10 12 14.5 16.5 10" />
        <path d="M4 17.5v1.5a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-1.5" />
    </Icon>
)

/* LOADING ICON — A ROUND THAT IS STILL ON ITS WAY */
export const LoadingIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <path d="M12 3.5a8.5 8.5 0 1 0 8.5 8.5" />
    </Icon>
)
